module.exports = __webpack_public_path__ + "img/sdg_en_(4).732bf7e2.png";